const BaseComponent = require('base/base-component');
const Server = require('helper/server');

class cpaGradesQuery extends BaseComponent {
  init () {
    Server.visitCount();
  }
}
module.exports = cpaGradesQuery;
